<template>

  <div class="row">
    <div class="col-12" v-if="stagesList">

      <h4 class="stage-results__title mt-5">{{'protocol.table_mastered_category' | trans}}</h4>

      <table-view
          :options="options"
          :isList=isMobile
          :isChange="isChange"
          class="stimulus_table"
      >

        <div slot="stageId" slot-scope="props" class="nowrap">
          <div>{{stageName(props.row.stageId)}}</div>
        </div>

        <div slot="masteredAt" slot-scope="props" class="nowrap">
          <div v-if="props.row.masteredAt">{{toLocaleDate(props.row.masteredAt)}}</div>
        </div>
        <div slot="startedAt" slot-scope="props" class="nowrap">
          {{toLocaleDate(props.row.startedAt)}}
        </div>
        <div slot="countSamples" slot-scope="props" class="nowrap">
          <div v-if="props.row.countSamples">{{props.row.countSamples}}</div>
        </div>

      </table-view>


    </div>
  </div>






</template>

<script>

  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import TableView from '../../../common/table/components/TableView';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import {LineNonNumericYChart, LineChartDataset, LineChart} from '../../../common/chart';
  import filter from 'lodash/filter';
  import Loader from '../../loader/components/Loader';
  import ChartPopup from './ChartPopup';
  import PromptChart from '../../chart/component/PromptChart';
  import CurrentStageMand from './CurrentStageMand';
  import toInteger from 'lodash/toInteger';
  import {chartStage} from '../../../mixins/chartStage';
  import {typeProtocol} from '../../../common/mixins/typeProtocol';
  
  export default {
    props: {
      'apiChartUrl': {
        type: [Number, String],
        default() {
          return '/protocols/assigned/pecs-with-discrimination/'
        }
      },
      'stage': {
        default() {
          return null;
        },
      },
      'stagesList': {
        default() {
          return null;
        },
      },
      'protocolId': {
        default() {
          return null;
        },
      },
      'rangeDateStartTimestamp': {
        default() {
          return null;
        },
      },
      'rangeDateEndTimestamp': {
        default() {
          return null;
        },
      },
      
      'teachingMethod': {
        default() {
          return null;
        },
      },


    },
    components: {
      TableView, LineChart, LineChartDataset, LineNonNumericYChart, Loader, ChartPopup, PromptChart, CurrentStageMand
    },

    mixins: [chartStage, typeProtocol],

    data() {
      return {
        message: '',
        isChange: false,
        options: {
          pageHeader: 'pecsWithDescrimination',
          initialPage: 1,
          perPage: 25,
          filterable: false,
          debounce: 1000,
          sortable: [],
          withSearch: false,
          skin: 'table table-sm',
          chosenStimul: [],
          columns: [
            {
              key: 'categoryTitle',
              changed: false,
              headings: lang.get('protocol.categoryTitle')
            },
            {
              key: 'stageId',
              changed: true,
              headings: lang.get('protocol.levelTitle')
            },
            {
              key: 'startedAt',
              changed: true,
              headings: lang.get('protocol.started_at')
            },
            {
              key: 'masteredAt',
              changed: true,
              headings:  lang.get('protocol.date_mastering')
            },
            {
              key: 'countSamples',
              changed: true,
              headings:  lang.get('protocol.countSamples')
            }

          ],
          templates: {
            masteredAt: this.masteredAt,
            startedAt: this.startedAt,
          },
          listRow: {
            categoryTitle: {
              headings: lang.get('protocol.categoryTitle'),
              hasTemplate: false,
            },
            startedAt: {
              headings: lang.get('protocol.started_at'),
              hasTemplate: true,
            },
            masteredAt: {
              headings: lang.get('protocol.date_mastering'),
              hasTemplate: true,
            },
            countSamples: {
              headings: lang.get('protocol.countSamples'),
              hasTemplate: false,
            },
          },
          requestFunction: this.requestFunction,
          responseAdapter: function (resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts: {
            filter: "",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
            count: "Страница {page} из {pages}",
          },
          columnsClasses: {
            countSamples: 'text-center',
          }
        },
        apiUrl: '/protocols/assigned/',
      };
    },

    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),

    },

    async created() {
      //this.chartShow();
    },

    methods: {

      stageName(id){
        let title = filter(this.stagesList, item => {
          return item.id == id;
        });
        return title.length ? title[0].description : this.stagesList[this.stagesList.length - 1].description;
      },

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      startedAt(h, row) {
        return row.startedAt ? this.toLocaleDate(row.startedAt) : '';
      },

      masteredAt(h, row) {
        return row.masteredAt ? this.toLocaleDate(row.masteredAt) : '';
      },

      name(h, row) {
        return lang.get(row.name);
      },

      async requestFunction (data) {
        this.isChange = false;
        localStorage.setItem('currentPage', data.page);
        localStorage.setItem('currentPageHeader', 'pecsWithDescrimination');
        return this.onSendRequest(this.options.perPage, data.page);
      },

      onSendRequest: async function (perPage, page) {
        this.list = [];

        let url = this.apiChartUrl + this.protocolId + '/category-introduced-mastered-history';

        let params = {
          perPage: perPage,
          page: page,
          stageId: this.stage ? this.stage.id : null,
        };
        let response = await axios.get(url, {params: params});

        forEach(response.data.data.items, item => {

          forEach(item.rowData, (rowData, index) => {

            this.list.push({
              categoryTitle: index === 0 ? item.categoryTitle : '',
              startedAt: rowData.startedAt,
              masteredAt: rowData.masteredAt,
              countSamples: rowData.countSamples,
              stageId: rowData.stageId
            })

          });

        });

        response.data.data.items = this.list

        //this.list = response.data.data.items;
        return response;
      },
      
    },

    watch:{
      showReport(newValue){


      }
    }


  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentPecsWithDescrimination.vue